import { render, staticRenderFns } from "./PdpTabGpsr.vue?vue&type=template&id=7c47dbd8&scoped=true"
import script from "./PdpTabGpsr.vue?vue&type=script&lang=js"
export * from "./PdpTabGpsr.vue?vue&type=script&lang=js"
import style0 from "./PdpTabGpsr.vue?vue&type=style&index=0&id=7c47dbd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47dbd8",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-tab-gpsr%2FPdpTabGpsr.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports